import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('expense-receipts', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('expense-receipts/metrics', { params, ...config }),
  codePreview: (params = {}, config = {}) => axios.get('expense-receipts/code-preview', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('expense-receipts', payload, config),
  counterpartPendingSelectors: (params = {}, config = {}) => axios.get('expense-receipts/counterparts/pending-selectors', { params, ...config }),
  applicationItems: (params = {}, config = {}) => axios.get('expense-receipts/application-items', { params, ...config }),
  show: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}`, { params, ...config }),
  cancel: (id, payload = {}, config = {}) => axios.post(`expense-receipts/${id}/cancel`, payload, config),
  downloadPdf: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/pdf`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadZip: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/zip`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadXml: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/xml`, {
    params,
    responseType: 'blob',
    ...config,
  }),
  downloadRequestsLatest: (params = {}, config = {}) => axios.get('expense-receipts/download-requests/latest', { params, ...config }),
  downloadRequestsShow: (requestId, params = {}, config = {}) => axios.get(`expense-receipts/download-requests/${requestId}`, { params, ...config }),
  downloadRequestsStore: (payload = {}, config = {}) => axios.post('expense-receipts/download-requests', payload, config),
  downloadRequestsDirectDownload: (payload = {}, config = {}) => axios.post(
    'expense-receipts/download-requests/direct-download',
    payload,
    {
      responseType: 'blob',
      ...config,
    },
  ),
  downloadRequestsRetryPackage: (requestId, packageId, payload = {}, config = {}) => axios.post(
    `expense-receipts/download-requests/${requestId}/packages/${packageId}/retry`,
    payload,
    config,
  ),
  downloadRequestsRegenerate: (requestId, payload = {}, config = {}) => axios.post(
    `expense-receipts/download-requests/${requestId}/regenerate`,
    payload,
    config,
  ),
  downloadRequestsDownloadPackage: (requestId, packageId, params = {}, config = {}) => axios.get(
    `expense-receipts/download-requests/${requestId}/packages/${packageId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  exportColumns: (config = {}) => axios.get('expense-receipts/exports/columns', config),
  exportFormats: (config = {}) => axios.get('expense-receipts/exports/formats', config),
  exportFormatStore: (payload = {}, config = {}) => axios.post('expense-receipts/exports/formats', payload, config),
  exportFormatUpdate: (formatId, payload = {}, config = {}) => axios.put(`expense-receipts/exports/formats/${formatId}`, payload, config),
  exportFormatDelete: (formatId, config = {}) => axios.delete(`expense-receipts/exports/formats/${formatId}`, config),
  exportExcel: (payload = {}, config = {}) => axios.post('expense-receipts/exports/excel', payload, {
    responseType: 'blob',
    ...config,
  }),
  sendExpenseReceipt: (id, payload = {}, config = {}) => axios.post(`send/expense-receipts/${id}`, payload, config),
  activity: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/activity`, { params, ...config }),
  shippingIndex: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/shipping`, { params, ...config }),
  documentsIndex: (id, params = {}, config = {}) => axios.get(`expense-receipts/${id}/documents`, { params, ...config }),
  documentsDownload: (id, documentId, params = {}, config = {}) => axios.get(
    `expense-receipts/${id}/documents/${documentId}/download`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
  documentsStore: (id, payload = {}, config = {}) => axios.post(`expense-receipts/${id}/documents`, payload, config),
  documentsUpdate: (id, documentId, payload = {}, config = {}) => axios.put(`expense-receipts/${id}/documents/${documentId}`, payload, config),
  documentsDelete: (id, documentId, config = {}) => axios.delete(`expense-receipts/${id}/documents/${documentId}`, config),
  documentsDownloadAll: (id, params = {}, config = {}) => axios.get(
    `expense-receipts/${id}/documents/download-all`,
    {
      params,
      responseType: 'blob',
      ...config,
    },
  ),
};
